import React, { FC, ReactNode } from 'react';

import { cn } from '@/shared/lib/tailwind-merge';

type SelectableCardProps = {
    icon: ReactNode;
    name: string;
    onClick: () => void;
    isActive?: boolean;
    className?: string;
};

export const SelectableCard: FC<SelectableCardProps> = ({
    icon,
    name,
    isActive,
    onClick,
    className,
}) => {
    return (
        <div
            data-testid={`selectable-card-${name}`}
            className={cn(
                'gap-[10px] bg-background-secondary rounded p-5 cursor-pointer w-[146px] flex flex-col items-center justify-center border border-transparent hover:border-border-accent',
                {
                    'border-border-accent': isActive,
                },
                className,
            )}
            onClick={onClick}
        >
            {icon}
            <div className='text-[14px] font-semibold text-content-primary font-[Inter]'>
                {name}
            </div>
        </div>
    );
};
